import { Component, Input, OnInit } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { LoggingService } from 'src/app/services/logging.service';
import { byteSizePipe } from 'src/app/pipes/byteSize.pipe';
import { DocumentTypeEnum } from 'src/app/constants/document-type.enum';
import { DocumentModel } from 'src/app/models/document.model';
import { TranslateService } from '@ngx-translate/core';

/**
 * A component that can retrieve and show Document/Request Information
 * Works for Pdf & Xbrl Documents
 */
@Component({
  selector: 'app-document-details-summary',
  templateUrl: './document-details-summary.component.html',
  styleUrls: ['../../../../assets/css/material-table.scss'],
  providers: [
    byteSizePipe
  ]
})
export class DocumentDetailsSummaryComponent implements OnInit {

  @Input() documentType!: string;

  @Input() documentGuid!: string;
  @Input() requestGuid!: string;
  @Input() documents!: DocumentModel[];
  /** 
   * Xbrl detail fields
   * Structured as Key + Value
   */
  xbrlDetails = <any>[];
  displayedColumns: any;
  tableDetails!: any;




  constructor(private DocumentService: DocumentApiClient, private byteSizePipe: byteSizePipe, private loggingService: LoggingService, private translateService: TranslateService) {
  }



  ngOnInit(): void {
    // Request Document details:
    if (this.documentType == DocumentTypeEnum.RegularPdf) {
      this.GetPDFData()
    }
    else {
      this.GetXBRLData().catch((error) => this.loggingService.logException(error));
    }
  }

  private async GetXBRLData() {
    (await this.DocumentService.getXBRLDetails(this.requestGuid, this.documentGuid)).subscribe({
      next: (value) => {
        if (value) {
          this.xbrlDetails = value;
        } else {
          this.xbrlDetails = [];
        }

      },
    })
  }

  private GetPDFData() {
    this.DocumentService.getDocumentForViewer(this.requestGuid!, this.documentGuid).then(value => {
      lastValueFrom(value).then((doc: any) => {
        this.xbrlDetails = [
          { key: "FileType", value: this.translateService.instant('Request.Document.' + doc.documentType) },
          { key: "FileSize", value: this.byteSizePipe.transform(doc.DocumentSize ?? doc.fileSize) },
          { key: "Pages", value: doc.pages },
          { key: "Checksum", value: doc.checksum }
        ]
      })
        .catch((error) => this.loggingService.logException(error))
    }).catch((error) => this.loggingService.logException(error));
  }

  getDocumentName() {
    return this.documents.find((p: { id: any; }) => p.id === this.documentGuid)?.name;
  }
}
